export default __webpack_public_path__ + "static/media/se-team.7643d8f1.svg";